import portalAppUrl from 'config/portal';

class RedirectHelper {
    getRedirectUrlWithUserSession(userSession) {
        if (typeof userSession === 'undefined') {
            return null;
        }

        const baseUrl = portalAppUrl;
        const urlHash = this.getUrlHashWithUserSession(userSession);

        return [baseUrl, urlHash].join('#');
    }

    getBaseUrl() {
        return portalAppUrl;
    }

    getUrlHashWithUserSession(userSession) {
        if (typeof userSession === 'undefined') {
            return null;
        }

        const urlHash = Object.entries({
                                           id_token: userSession.idToken.jwtToken,
                                           access_token: userSession.accessToken.jwtToken,
                                           refresh_token: userSession.refreshToken.token,
                                       })
            .map(
                ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
            )
            .join('&');

        return urlHash;
    }
}

const redirectHelper = new RedirectHelper();

export const useRedirectUrl = ({application, session}) => {
    if (typeof application === 'undefined') {
        throw new Error('application is required parameter');
    }

    if (
        !Object.prototype.hasOwnProperty.call(application, 'origin') ||
        !Object.prototype.hasOwnProperty.call(application, 'pathname')
    ) {
        throw new Error(
            'application origin and pathname are required parameters' +
            JSON.stringify(application)
        );
    }

    const baseUrl = application.origin + application.pathname;

    const urlHash = redirectHelper.getUrlHashWithUserSession(session);
    const redirectUrl = [baseUrl, urlHash].join('#');

    return redirectUrl;
};
